export default "__VITE_ASSET__KTYL7xFW__"